"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var AlignDirection;
(function (AlignDirection) {
    AlignDirection["RIGHT"] = "end";
    AlignDirection["LEFT"] = "start";
})(AlignDirection = exports.AlignDirection || (exports.AlignDirection = {}));
var Align = function (_a) {
    var children = _a.children, _b = _a.dir, dir = _b === void 0 ? AlignDirection.LEFT : _b, _c = _a.className, className = _c === void 0 ? null : _c;
    return (react_1.default.createElement("div", { className: "flex " + (dir === AlignDirection.RIGHT ? 'justify-end' : '') + " " + className }, children));
};
exports.default = Align;
//# sourceMappingURL=index.js.map